import Swal from 'sweetalert2'

const SweetAlert = (props:any) => {
    return Swal.fire({
        ...props,
        confirmButtonColor: "#12b7ad"
    })
}

export default SweetAlert